// Local Deps
import { makeGraphQLRequest } from '../../utils/requestUtils';

/*-----------------------
    REQUEST USER ID
-------------------------*/
// export async function mySupplierCaps(id) {
//   // Format Query
//   const query = `query mySupplierCaps($id: ID ) { 
//     supplierSearch(ID: $id )
//     { 
//       suppliers{
//         supplierCapabilities{
//           cage,
//           company,
//           additionOptions,
//           alloy,
//           bizClass,
//           castings,
//           coreProcesses,
//           fsc,
//           lowVolume,
//           material,
//           qualityCerts,
//           rapidTooling,
//           simulationCapability
//         }
//       }
//     } 
//   }`;

//   // Variables
//   const variables = {
//     id,
//   };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }

/*-----------------------
    UPDATE Caps
-------------------------*/

export async function updateCaps(supplierCaps) {
  // Format Mutation
  const query = `mutation updateSupplierCaps( $supplierCaps: EditSupplierCapsInput ) {
     updateSupplierCaps (supplierCaps: $supplierCaps) { 
       cage, 
       company,  
       additionOptions, 
       alloy, 
       approvedSource, 
       bizClass,  
       castings, 
       componentWeight, 
       coreProcesses,  
       fsc, 
       lowVolume,   
       material, 
       qualityCerts, 
       rapidTooling,  
       simulationCapability,

       statusCode,
       message
      }
     }`;

  // Variables
  const variables = {
    supplierCaps,
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function querySupplierCapsForautoComplete(criteria) {
  // Format query
  console.log(criteria);
  const query = `query SupplierSearch($criteria: SupplierSearchInput ) { 
    supplierSearch(supplierCriteria: $criteria )
    { 
      suppliers{
        
          cage,
          company,
          
        
      }
      supplierAggs
    } 
  }`;
  // Variables
  const variables = { criteria: { ...criteria } };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.supplierSearch;
}

export async function getOrgNameAndCageCode(id) {
  // Format Query
  const query = `query organization($id: ID) {
    organization(id: $id) {      
      name, 
      cageCode,   
      }
    }`;

  // Variables
  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}



// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/EditSupplierCapsQL.js